module.exports = __webpack_public_path__ + "img/b_Forsmax_3-2.d489c2e2.jpeg";